import React from "react";
import { defaults, crudAll, CRUDStringLists, ResourceDescriptor, SelectOption } from "./common";
import { Link } from "react-router-dom";
import { formatDurationHours } from "../components/DurationField";
import DeleteResourceButton from "../components/DeleteResourceButton";
import NotSetValue from "../components/NotSetValue";
import { FormattedMessage } from "react-intl";

function generateOrders(): CRUDStringLists {
    if (global.identityProvider === "internal") {
        return {
            list: ["display_name", "redirect_uris", "ldap_auth", "controlHeaderCell"],
            update: ["display_name", "identifier", "secret", "redirect_uris", "ldap_auth", "refresh_token_expires_in"],
        };
    }
    return {
        list: ["display_name", "controlHeaderCell"],
        update: ["display_name", "identifier", "secret"],
    };
}

export function isInternalClient(clientData) {
    return window.selfClientId == clientData.id;
}

const client: ResourceDescriptor = {
    url: "clients",
    orders: generateOrders(),
    crudActions: crudAll,
    listDefaults: defaults.list,
    optionsFormatter: (row: any): SelectOption => {
        return { value: row.id, text: row.display_name };
    },
    renderers: {
        read: {
            redirect_uris: (val, row) => {
                // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
                if (val.length == 1) return val[0];
                let list = [];
                for (let v of val) list.push(<li>{v}</li>);
                return <ul>{...list}</ul>;
            },
            ldap_auth: (val, row) => {
                if (val) return <span>{`${val.host}:${val.port}`}</span>;
                else return <NotSetValue />;
            },
            refresh_token_expires_in: (val, row) => {
                return formatDurationHours(val);
            },
        },
        list: {
            ldap_auth: (val, row) => {
                // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
                if (val) return `${val.host}:${val.port}`; // Maybe TODO: put a link to ldap read page
                else return <NotSetValue />;
            },
            redirect_uris: (val, row) => {
                // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
                return val ? val.join(", ") : "";
            },
            display_name: (val, row) => {
                return isInternalClient(row) ? val : <Link to={`/clients/read/${row.id}`}>{val}</Link>;
            },
            controlHeaderCell: (val, row) => {
                let isInternal = isInternalClient(row);
                return (
                    <div>
                        <DeleteResourceButton
                            id={row.id}
                            disabled={isInternal}
                            tooltip={
                                <FormattedMessage id={isInternal ? "client.delete_disabled_self" : "client.delete"} />
                            }
                            resourceName="client"
                        />
                    </div>
                );
            },
        },
    },
    expand: {
        read: ["ldap_auth", "roles.client_role_mapping_rules.context_substitutions", "roles.role_contexts.context"],
        list: ["ldap_auth"],
    },
    identifiers: ["display_name"],
    resourceSchemaPostProcessor: (schema) => {
        const refresh_token_expires_in = schema["refresh_token_expires_in"];
        refresh_token_expires_in.type.name = "Duration";
    },
};

export default client;
